/**
 * A question's stem is either the newer `blocks` list, or (for every
 * question authored before it existed) three flat fields. Every renderer —
 * admin builder, mobile exam screens — wants one list to iterate, so this is
 * the single place that reconciles the two shapes. When `blocks` is present
 * it wins outright; the legacy fields are never merged in alongside it.
 */
export function resolveContentBlocks(content) {
    if (content.blocks && content.blocks.length > 0)
        return content.blocks;
    const blocks = [];
    if (content.text) {
        blocks.push({ id: 'legacy-text', type: 'text', text: content.text });
    }
    if (content.imageUrl) {
        blocks.push({ id: 'legacy-image', type: 'image', imageUrl: content.imageUrl });
    }
    if (content.audioUrl) {
        blocks.push({
            id: 'legacy-audio',
            type: 'audio',
            audioUrl: content.audioUrl,
            ...(content.audioPlayLimit && { audioPlayLimit: content.audioPlayLimit }),
        });
    }
    return blocks;
}
//# sourceMappingURL=content-blocks.js.map